import PubSub from "underpub-js";

var ListingReferences = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingReferences',
	};

	$.extend(true, this.options, options);

};

ListingReferences.prototype.init = function() {

	var self = this;

};

export default ListingReferences;
